export default "__VITE_ASSET__CGi_VBri__"